export enum EXCEL_CELL_TYPES {
	GENERAL = 'General',
	NUMERIC = 'Numeric',
	CURRENCY = 'Currency',
	TEXT = 'Text',
	CUSTOM = 'Custom'
}
